import React from 'react'
import { Redirect } from 'react-router-dom'
import PaymentInformation from '../modules/PaymentInformation'
import ThingsToKnow from '../modules/ThingsToKnow'
import DataSource from '../DataSource'
import AjaxLoader from '../components/AjaxLoader'
import globals from '../globals'
import { connect } from 'react-redux'
import MigrateMobileModule from '../modules/MigrateMobileModule'

class MigrateMobile extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            hasError: false,
            numbers: []
        }
    }

    componentDidMount () {
        this.getServices()
    }

    async getServices () {
        await DataSource.getData('/api/getOptusMigrationServices', result => {
            this.setState({
                numbers: result,
                isLoaded: true
            }, () => globals.animatePageIn(this.container))
        }, () => {
            this.setState({ hasError: true, isLoaded: true })
        })
    }

    render () {
        if (!this.state.isLoaded) {
            return <AjaxLoader />
        }

        return (
            <div ref={el => this.container = el} style={{ opacity: 0 }}>
                <MigrateMobileModule
                    isLoaded={this.state.isLoaded}
                    hasError={this.state.hasError}
                    numbers={this.state.numbers}
                />
                {this.state.numbers.length > 0
                    ? <React.Fragment>
                        <PaymentInformation />
                        <ThingsToKnow type='migrateMobile' />
                      </React.Fragment>
                    : ''}
            </div>
        )
    }
}

const mapStateToProps = state => ({
    customerId: state.auth.id
})

export default connect(mapStateToProps)(MigrateMobile)



// WEBPACK FOOTER //
// ./resources/js/pages/MigrateMobile.js